import { createFileRoute } from "@tanstack/react-router";
import MasiniSecondHandHub from "@/pages/MasiniSecondHandHub";
import { routeHead } from "@/lib/seo/route-head";
import { listingsV2QueryOptions } from "@/lib/queries/publicData";

export const Route = createFileRoute("/masini-second-hand/")({
  head: () => {
    const base = routeHead('/masini-second-hand/');
    return { ...base, scripts: [{ type: 'application/ld+json', children: JSON.stringify({
      '@context': 'https://schema.org', '@type': 'CollectionPage', name: 'Mașini second hand pe mărci și orașe',
      url: 'https://roautomarket.ro/masini-second-hand',
      about: { '@type': 'Thing', name: 'Anunțuri de autoturisme în România' },
    }) }] };
  },
  // Same query/cache key as the brand/city pages; server-rendered so the
  // directory and newest listing links are present in the initial HTML.
  loader: async ({ context }) =>
    (await context.queryClient
      .ensureQueryData(listingsV2QueryOptions({ country_code: "RO", limit: 2000 }))
      .catch(() => [])) ?? [],
  component: RouteComponent,
});

function RouteComponent() {
  const rows = Route.useLoaderData();
  return <MasiniSecondHandHub rows={(rows ?? []) as never} />;
}
